export default class ComponenteArquivoOptions {
  constructor({
    ticketId = 0,
    componenteId = 0,
    fetchFiles = false,
  } = {}) {
    this.ticketId = ticketId
    this.componenteId = componenteId
    this.fetchFiles = fetchFiles
  }
}
